import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';

const RadioList = ({
  children,
  disabled,
  name,
  value,
  onChange,
  orientation,
  color,
  ...rest
}) => {
  const classes = useStyle({ orientation });

  const handleChange = (val) => () => {
    onChange(val);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...child.props,
        checked: value === child.props.value,
        onChange: handleChange(child.props.value),
        disabled: disabled || child.props.disabled,
        color: color || child.props.color,
      });
    }
    return child;
  });

  return (
    <div
      role="radiogroup"
      className={classes.radioList}
      {...rest}>
      {childrenWithProps}
    </div>
  );
};

RadioList.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  color: PropTypes.string,
};

RadioList.defaultProps = {
  disabled: false,
  value: undefined,
  orientation: 'vertical',
  color: undefined,
};

export default RadioList;
